import React from 'react';

export const ToIcon = ({ width = '24', height = '24' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7768 10.778L4.97266 4.97389M3.44526 6.50129L6.50007 3.44648L2.8343 1.6136L1.61238 2.83552L3.44526 6.50129ZM21.7435 8.30362C22.3302 7.71749 22.7338 6.97343 22.9052 6.16205C23.0766 5.35066 23.0084 4.50695 22.7089 3.73363L20.9713 5.47121H18.5274V3.02736L20.265 1.28979C19.4916 0.989614 18.6477 0.920845 17.8359 1.09186C17.0241 1.26287 16.2796 1.66629 15.6931 2.25296C15.1066 2.83963 14.7033 3.58422 14.5325 4.39602C14.3616 5.20783 14.4306 6.05179 14.7309 6.8251L6.8251 14.7322C6.05179 14.4318 5.20783 14.3629 4.39602 14.5337C3.58422 14.7045 2.83963 15.1078 2.25296 15.6943C1.66629 16.2809 1.26287 17.0254 1.09186 17.8371C0.920845 18.6489 0.989615 19.4929 1.28979 20.2662L3.02614 18.5287H5.46999V20.9725L3.73241 22.7101C4.50559 23.0103 5.34937 23.0791 6.16099 22.9083C6.97261 22.7375 7.71705 22.3344 8.30366 21.748C8.89026 21.1617 9.29372 20.4174 9.46488 19.6059C9.63605 18.7943 9.56755 17.9505 9.26772 17.1772L17.176 9.26894C17.949 9.56792 18.7922 9.63586 19.6031 9.46448C20.414 9.2931 21.1576 8.8898 21.7435 8.30362Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.752 15.0548L18.5996 21.9025C18.7528 22.056 18.9348 22.1778 19.1352 22.2609C19.3355 22.344 19.5503 22.3867 19.7672 22.3867C19.984 22.3867 20.1988 22.344 20.3991 22.2609C20.5995 22.1778 20.7815 22.056 20.9347 21.9025L21.9025 20.9347C22.056 20.7815 22.1778 20.5995 22.2609 20.3991C22.344 20.1988 22.3867 19.984 22.3867 19.7672C22.3867 19.5503 22.344 19.3355 22.2609 19.1352C22.1778 18.9348 22.056 18.7528 21.9025 18.5996L15.0548 11.752"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
